import { render, staticRenderFns } from "./CabinetBedCalculator.vue?vue&type=template&id=7bb42904"
import script from "./CabinetBedCalculator.vue?vue&type=script&lang=js"
export * from "./CabinetBedCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports